export default __webpack_public_path__ + "static/media/41.4b46d305.jpg";